module.exports = __webpack_public_path__ + "assets/media/2.52a79adc.wav";